/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getBuildVariant = (): string | undefined => window.BUILD_VARIANT;
